import React from 'react';
import styles from './CardSkeleton.module.css';

const VARIANT_MAP = {
  kpi: styles.kpi,
  chart: styles.chart,
  funnel: styles.funnel,
  table: styles.table,
};

const CardSkeleton = ({ cardType = 'kpi' }) => (
  <div className={VARIANT_MAP[cardType] || styles.kpi} data-testid="card-skeleton" />
);

export default CardSkeleton;
